import './style.scss';

export default {
    load: function(id) {
      let form = document.getElementById(id);
      form.classList.add('position-relative')

      Object.values(form.getElementsByClassName("alert-custom")).forEach((el) => {
        el.remove();
      });

      let loader = document.createElement("div");
      loader.classList.add("form-loader");
      form.prepend(loader);
    },

    stopLoading: function(msg = null) {
      Object.values(document.getElementsByClassName("invalid-feedback")).forEach(
        (e) => {
          e.remove();
        }
      );

      Object.values(document.getElementsByClassName("form-control")).forEach(
        (input) => {
          input.classList.remove('is-invalid')
        }
      );

      Object.values(document.getElementsByClassName("alert-custom")).forEach((el) => {
        el.remove();
      });

      Object.values(document.getElementsByClassName("form-loader")).forEach(
        (el) => {
          if (msg) {
            let form = el.parentElement;
            let message = document.createElement("div");
            message.classList.add("alert");
            message.classList.add("alert-danger");
            message.classList.add("alert-custom");
            message.classList.add("mb-2");
            message.innerHTML = msg;
            form.prepend(message);
          }

          el.remove();
        }
      );
    },

    handle: function(response) {
      Object.values(document.getElementsByClassName("form-loader")).forEach(
        (el) => {
          el.remove();
        }
      );

      if (response.status == 422) {
        if (response.config.data) {
          let data = {}

          if(typeof response.config.data == 'string') {
            data = JSON.parse(response.config.data);
          } else {
            data = { form_id: response.config.data.get('form_id') }
          }

          if (data.form_id) {
            this.handleInputs(data.form_id, response);
          }
        }
      } else {
        let wrapper = document.createElement('div')
        wrapper.classList.add('error-wrapper')

        let modal = document.createElement('div')
        modal.classList.add('error-modal')

        let img = document.createElement('img')
        img.src = '/images/icons/error.png'

        let title = document.createElement('h1')
        title.innerHTML = 'FAILED!'

        let msg = document.createElement('p')
        msg.innerHTML = 'There was a critical error processing your request. Please try again later'

        let link = document.createElement('a')
        link.href = '/'
        link.classList.add('btn')
        link.classList.add('btn-primary')
        link.innerHTML = 'Go Home'

        modal.append(img)
        modal.append(title)
        modal.append(msg)
        modal.append(link)

        wrapper.append(modal)

        document.getElementById('main_page_content').replaceWith(wrapper)
      }
    },

    handleInputs: function(id, response) {
      let form = document.getElementById(id);

      Object.values(form.getElementsByClassName("invalid-feedback")).forEach((e) => {
        e.remove();
      });

      let inputs = Object.values(form.getElementsByClassName("form-control"));
      let errors = response.data.errors;

      inputs.forEach((input) => {
        input.classList.remove('is-invalid')

        if (Object.keys(errors).indexOf(input.name) >= 0) {
          input.classList.add('is-invalid')
          let parent = input.parentElement;
          let msg = document.createElement("span");
          msg.classList.add("invalid-feedback");
          msg.innerHTML = errors[input.name][0];

          parent.append(msg);
        }
      });
    }
};
